import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules, UrlMatcher } from '@angular/router';
import { TbAuthGuard } from '@tb/auth';
import { CookieManagement } from './core/services/CookieManagement.service';

const customMatcher: UrlMatcher = (segments, group, route) => {
    if (segments.length > 0 && segments[0].path.toLowerCase() == 'eLearning'.toLowerCase()) {
        let completeRoute: string = '';
        segments.forEach((segment) => {
            completeRoute = `${completeRoute}/${segment}`
        })
        localStorage.setItem('directCourseLink', `${completeRoute}/index.html`.substring(1, `${completeRoute}/index.html`.length));
        return { consumed: segments };
    }
    return null;
};

const routes: Routes = [
    { matcher: customMatcher, redirectTo: 'home' },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    { path: '', loadChildren: () => import('./portal/portal.module').then((m) => m.PortalModule), canActivate: [TbAuthGuard] }, //dynamic import
    { path: 'store', loadChildren: () => import('./store/store.module').then((m) => m.StoreModule), canActivate: [TbAuthGuard] },
    { path: 'cms-editor', loadChildren: () => import('./cmseditor/cmseditor.module').then((m) => m.CmseditorModule) },
    { path: 'industry-editor', loadChildren: () => import('./industryeditor/industryeditor.module').then((m) => m.IndustryModule) },
    { path: '', loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule) },
    { path: '**', redirectTo: 'home' },
];

export const AppRoutingModule: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
    // useHash: true,
    // enableTracing: true,
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy',
});
